import { Output, EventEmitter, Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, Input } from '@angular/core';
import { CreditorAccount } from '@feature/creditor-accounts/models/creditor-account-model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'creditor-accounts-body',
  templateUrl: './creditor-accounts-body.component.html'
})
export class CreditorAccountsBodyComponent implements OnInit, OnDestroy {

  @Input()
  accounts: CreditorAccount[] = [];

  @Output()
  accountClick = new EventEmitter<CreditorAccount>();

  pickName(account: CreditorAccount) {
    return account.FamiliarName ? account.FamiliarName : account.CreditorName;
  }

  get canClick() {
    return this.accounts.length > 1;
  }

  ngOnInit(): void {

  }

  ngOnDestroy() {

  }

  handleClick(account: CreditorAccount) {
    this.accountClick.emit(account);
  }

}
